import {DynForm} from "./dyn-form";
import {DynField} from "./dyn-field";
import {DynBooleanField} from "./fields/dyn-boolean-field";
import {DynSubformField} from "./fields/dyn-subform-field";
import {DynTextAreaField} from "./fields/dyn-text-area-field";
import {DynTextField} from "./fields/dyn-text-field";
import {DynSelectField} from "./fields/select/dyn-select-field";
import {DynSelectFieldOptionsCity} from "./fields/select/dyn-select-field-options-city";
import {DynSelectFieldOptionsMinistryArea} from "./fields/select/dyn-select-field-options-ministry-area";
import {DynSelectFieldOptionsMinistry} from "./fields/select/dyn-select-field-options-ministry";
import {DynSelectFieldOptionsString} from "./fields/select/dyn-select-field-options-string";
import {DynSelectFieldOptions} from "./fields/select/dyn-select-field-options";
import {City} from "../../../profile/domain/city";
import {MinistryArea} from "../../../profile/domain/ministry/ministry-area";
import {Ministry} from "../../../profile/domain/ministry/ministry";
import {DynOptionStringItem} from "./fields/select/dyn-option-string-item";
import {DynDateField} from "./fields/temporal/dyn-date-field";
import {DynTimeField} from "./fields/temporal/dyn-time-field";
import {DynStaticTextField} from "./fields/dyn-static-text-field";
import {DynFillableTextField} from "./fields/dyn-fillable-text-field";
import {DynSignatureField} from "./fields/dyn-signature-field";

export class FormUtils {
  public static parseForm(
    object: any,
    options: Array<DynSelectFieldOptions<any>> = null,
    subforms: Array<DynForm> = null
  ): DynForm {
    //console.log(object);
    const form = this.parseFlatForm(object);
    this.setFormFields(form, object, options, subforms);
    return form;
  }

  public static parseSubform(object: any) {
    const form = this.parseFlatForm(object);
    this.setFormFields(form, object);
    return form;
  }

  public static parseFlatForm(object: any): DynForm {
    const form = new DynForm();
    form.setId(object.id);
    form.setName(object.name);
    form.setVersion(object.version);
    form.setDescription(object.description);
    form.setReferenceNumber(object.referenceNumber);
    form.setSubform(object.subform);
    form.setValidSince(object.validSince);
    form.setValidUntil(object.validUntil);
    form.setState(object.state);
    form.setFields(null);
    form.image = object.image;
    form.setMinistry(object.ministry);
    return form;
  }

  private static setFormFields(
    form: DynForm,
    object: any,
    options: Array<DynSelectFieldOptions<any>> = null,
    subforms: Array<DynForm> = null
  ) {
    form.setFields(
      object.fields.map(f => this.parseField(f, options, subforms))
    );
  }

  public static parseField(
    object: any,
    options: Array<DynSelectFieldOptions<any>> = null,
    subforms: Array<DynForm> = null
  ) {
    switch (object.type) {
      case "boolean":
        return this.parseBooleanField(object);
      case "date":
        return this.parseDateField(object);
      case "select":
        return this.parseSelectField(object, options);
      case "subform":
        return this.parseSubformField(object, options, subforms);
      case "textarea":
        return this.parseTextAreaField(object);
      case "text":
        return this.parseTextField(object);
      case "time":
        return this.parseTimeField(object);
      case "static-text":
        return this.parseStaticText(object);
      case "fillableText":
        return this.parseFillableText(object);
      case "signature":
        return this.parseSignature(object);
    }
  }

  public static parseFillableText(object: any){
    const field = new DynFillableTextField();
    this.setFieldFromObject(field,object);
    return field;
  }

  public static parseStaticText(object: any) {
    const field = new DynStaticTextField();
    this.setFieldFromObject(field, object);
    return field;
  }

    public static parseSignature(object: any) {
        const field = new DynSignatureField();
        this.setFieldFromObject(field, object);
        return field;
    }


    public static parseBooleanField(object: any) {
    const field = new DynBooleanField();
    this.setFieldFromObject(field, object);
    return field;
  }
  public static parseDateField(object: any) {
    const field = new DynDateField();
    this.setFieldFromObject(field, object);
    return field;
  }
  public static parseSelectField(
    object: any,
    options: Array<DynSelectFieldOptions<any>> = null
  ) {
    const field = new DynSelectField();
    this.setFieldFromObject(field, object);
    field.setOptions(
      options
        ? options.find(opt => opt.id === object.options.id)
        : object.options
    );
    return field;
  }

  public static parseSubformField(
    object: any,
    options: Array<DynSelectFieldOptions<any>> = null,
    subforms: Array<DynForm> = null
  ) {
    const field = new DynSubformField();
    this.setFieldFromObject(field, object);
    field.setForm(
      subforms
        ? this.parseForm(
            subforms.find(sf => sf.id === object.form.id),
            options,
            subforms
          )
        : object.form
    );
    return field;
  }
  public static parseTextAreaField(object: any) {
    const field = new DynTextAreaField();
    this.setFieldFromObject(field, object);
    return field;
  }
  public static parseTextField(object: any) {
    const field = new DynTextField();
    this.setFieldFromObject(field, object);
    return field;
  }
  public static parseTimeField(object: any) {
    const field = new DynTimeField();
    this.setFieldFromObject(field, object);
    return field;
  }

  private static setFieldFromObject(target: DynField, source: any) {
    target.setId(source.id);
    target.setType(source.type);
    target.setName(source.name);
    target.setLabel(source.label);
    target.setAlignment(source.alignment);
    target.setReferenceLabel(source.referenceLabel);
    target.setRequired(source.required);
    target.setMin(source.min);
    target.setMax(source.max);
    target.setPattern(source.pattern);
    target.setText(source.text);
    target.setOrder(source.order);
    target.setDivider(source.divider);
    target.setDefaultValue(source.defaultValue);
  }

  public static parseSelectFieldOptions(
    object: any
  ): DynSelectFieldOptions<any> {
    // console.log(object);
    switch (object.type) {
      case "city":
        return this.parseSelectFieldOptionsCity(object);
      case "ministryArea":
        return this.parseSelectFieldOptionsMinistryArea(object);
      case "ministry":
        return this.parseSelectFieldOptionsMinistry(object);
      case "string":
        return this.parseSelectFieldOptionsString(object);
    }
  }

  public static parseSelectFieldOptionsCity(
    object: any
  ): DynSelectFieldOptionsCity {
    const sfo = new DynSelectFieldOptionsCity();
    this.setSelectFieldOptionsFromObject(sfo, object);
    sfo.setOptions(object.options.map(o => new City(o)));
    return sfo;
  }
  public static parseSelectFieldOptionsMinistryArea(
    object: any
  ): DynSelectFieldOptionsMinistryArea {
    const sfo = new DynSelectFieldOptionsMinistryArea();
    this.setSelectFieldOptionsFromObject(sfo, object);
    sfo.setOptions(object.options.map(o => new MinistryArea(o)));
    return sfo;
  }
  public static parseSelectFieldOptionsMinistry(
    object: any
  ): DynSelectFieldOptionsMinistry {
    const sfo = new DynSelectFieldOptionsMinistry();
    this.setSelectFieldOptionsFromObject(sfo, object);
    sfo.setOptions(object.options.map(o => new Ministry(o)));
    return sfo;
  }
  public static parseSelectFieldOptionsString(
    object: any
  ): DynSelectFieldOptionsString {
    const sfo = new DynSelectFieldOptionsString();
    this.setSelectFieldOptionsFromObject(sfo, object);
    sfo.setOptions(object.options.map(o => new DynOptionStringItem(o)));
    return sfo;
  }

  public static setSelectFieldOptions(
    selectField: DynSelectField,
    optionsList: Array<DynSelectFieldOptions<any>>
  ) {
    selectField.setOptions(
      optionsList.find(o => o.getId() === selectField.getOptions().getId())
    );
  }

  public static setSelectFieldOptionsFromObject(
    target: DynSelectFieldOptions<any>,
    source: any
  ) {
    target.setId(source.id);
    target.setType(source.type);
    target.setName(source.name);
  }

  public static labelToName(label: string): string {
    // console.log(label);
    const name = label
      .slice()
      .trim()
      .toLowerCase()
      .replace(/á/g, "a")
      .replace(/é/g, "e")
      .replace(/í/g, "i")
      .replace(/ó/g, "o")
      .replace(/ú/g, "u")
      .replace(/ñ/g, "nn")
      .replace(/\W+/g, "_");
    // console.log(name);
    return name;
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/form-utils.ts